export const cloneObject = (data: Record<string, unknown> | Record<string, unknown>[] | string[]) => JSON.parse(JSON.stringify(data));
